import React from 'react'
import { Grid, Typography, Box } from '@mui/material';
import Container from '@mui/material/Container';
import PriceDetails from '../components/PriceDetails/PriceDetails';

const labels = {
  si: {
    title: 'පැකේජ',
    subtitle: 'ඔබට සුදුසුම පැකේජය තෝරන්න',
  },
  en: {
    title: 'Pricing',
    subtitle: 'Choose the package that suits you',
  }
};

const PricingPage = () => {
  const [lang, setLang] = React.useState(() => localStorage.getItem('language') || 'si');

  React.useEffect(() => {
    // Listen to storage events (for cross-tab communication)
    const onStorage = (e) => {
      if (e.key === 'language' && e.newValue) setLang(e.newValue);
    };
    window.addEventListener('storage', onStorage);

    // Poll for language changes (for same-tab updates)
    const interval = setInterval(() => {
      const currentLang = localStorage.getItem('language') || 'si';
      setLang(prevLang => {
        if (prevLang !== currentLang) {
          return currentLang;
        }
        return prevLang;
      });
    }, 500);

    return () => {
      window.removeEventListener('storage', onStorage);
      clearInterval(interval);
    };
  }, []);

  const t = labels[lang] ?? labels.si;

  return (
    <React.Fragment>
      <Container maxWidth="lg"
        sx={{
          backgroundImage: 'url(../../images/bg-wedding2.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'bottom',
          backgroundRepeat: 'no-repeat',
          py: 4,
        }}
      >
        <Box sx={{ textAlign: 'center', mb: 4, mt: 4 }}>
          <Typography
            variant="h3"
            component="h1"
            sx={{
              fontSize: { xs: '2rem', md: '3rem' },
              fontWeight: 800,
              mb: 2,
              background: 'linear-gradient(135deg, #71123e 0%, #8b1a4f 50%, #C3937C 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              color: 'text.primary',
            }}
          >
            {t.title}
          </Typography>
          <Typography variant="h6" sx={{ color: 'text.secondary', mb: 4 }}>
            {t.subtitle}
          </Typography>
        </Box>
        <Grid container rowSpacing={1}
          sx={{
            minHeight: { xs: 'auto', md: '90vh' },
            display: 'flex', justifyContent: 'center', borderRadius: '1rem', alignItems: 'center'
          }}>
          <Grid item xs={12} sm={6} md={4} >
            <PriceDetails discount={0} fullPrice={1250} pricePerMonth={1250} month={1} />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <PriceDetails discount={77.33} fullPrice={3750} pricePerMonth={2900} month={3} />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <PriceDetails discount={65.48} fullPrice={7330} pricePerMonth={4800} month={6} />
          </Grid>
        </Grid>
      </Container>
    </React.Fragment>
  )
}

export default PricingPage;